import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submit"];

  formatEIN(event) {
    let value = event.target.value.replace(/\D/g, "").slice(0, 9);
    if (value.length > 2) {
      value = value.slice(0, 2) + "-" + value.slice(2);
    }
    event.target.value = value;
  }

  formatSSN(event) {
    let value = event.target.value.replace(/\D/g, "").slice(0, 9);
    if (value.length > 3 && value.length <= 5) {
      value = value.slice(0, 3) + "-" + value.slice(3);
    } else if (value.length > 5) {
      value = value.slice(0, 3) + "-" + value.slice(3, 5) + "-" + value.slice(5);
    }
    event.target.value = value;
  }

  formatPhone(event) {
    let value = event.target.value.replace(/\D/g, "");
    if (value.length > 3 && value.length <= 6) {
      value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
    } else if (value.length > 6) {
      value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
    }
    event.target.value = value;
  }

  formatNumber(event) {
    let value = event.target.value.replace(/\D/g, "");
    event.target.value = value;
  }

  formatMoney(event) {
    let value = event.target.value.replace(/\D/g, "");
    let formattedValue = Number(value).toLocaleString();
    event.target.value = formattedValue;
  }

  formatDollarsAndCents(event) {
    let value = event.target.value.replace(/[^\d.]/g, "");
    if (value.length > 0) {
      if (value === ".") {
        value = "0.";
      } else if (value.startsWith("00")) {
        value = "0";
      } else if (value.indexOf(".") !== value.lastIndexOf(".")) {
        value = value.slice(0, value.lastIndexOf("."));
      } else if (value.indexOf(".") !== -1 && value.length - value.indexOf(".") > 3) {
        value = value.slice(0, value.indexOf(".") + 3);
      }

      let parts = value.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      value = parts.join(".");
    }
    event.target.value = value;
  }

  formatYYYY(event) {
    let value = event.target.value.replace(/\D/g, "").slice(0, 4);
    event.target.value = value;
  }

  formatZip(event) {
    let value = event.target.value.replace(/\D/g, "").slice(0, 5);
    event.target.value = value;
  }

  showLoader() {
    this.submitTarget.querySelector("svg.animate-spin").classList.remove("hidden");
  }

  hideLoader() {
    this.submitTarget.querySelector("svg.animate-spin").classList.add("hidden");
  }

  disableButton() {
    this.submitTarget.setAttribute("disabled", "disabled");
    this.submitTarget.querySelector("svg.animate-spin").classList.remove("hidden");
  }

  submitDebounced({ params: { delay = 300 } = {} } = {}) {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.element.requestSubmit();
    }, delay);
  }

  submit(event) {
    this.submitDebounced(event);
  }

  // List it after an action that can claim the key, such as datalist#navigate
  // picking a suggestion, so that Enter does one thing.
  submitOnEnter(event) {
    if (event.defaultPrevented) return;

    if (event.key === "Enter") {
      event.preventDefault();
      event.target.closest("form")?.requestSubmit();
      event.target.setAttribute("disabled", "disabled");
    }
  }
}
